module.exports = __webpack_public_path__ + "img/RJC_LP_head.5ecdfa4.jpg";